import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class BottomMessageModuleTerms extends BaseTerms {
  WEB_COOKIE_CONSENT_TEXT = "We use cookies to improve and personalize your experience on our website.By continuing to browse our site you agree to our ";
  WEB_COOKIE_POLICY_LINK = "Cookie Policy";
  WEB_COOKIE_ACCEPT_BUTTON = "Got it!";
}
